import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface IDataTitle {
  dataTitle: string;
  data: string | number | null | undefined;
}

export const DataTitle = ({ dataTitle, data }: IDataTitle) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack width={'auto'} gap={isDesktop ? '8px' : '4px'}>
      <Typography variant={'body6'} component='h3'>
        {dataTitle || ''}
      </Typography>
      <Typography variant={'body2'} whiteSpace='nowrap'>
        {data || Dictionary[DICTIONARY.PersonalDetails].noData}
      </Typography>
    </Stack>
  );
};
